"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListOption = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var ListOption = /** @class */function (_super) {
  __extends(ListOption, _super);
  function ListOption() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ListOption.prototype.render = function () {
    var _a;
    var _b = this.props,
      className = _b.className,
      children = _b.children,
      focused = _b.focused,
      selected = _b.selected,
      disabled = _b.disabled,
      readOnly = _b.readOnly,
      empty = _b.empty,
      role = _b.role;
    var customProps = _1.omit(this.props, Object.keys(ListOption.propTypes));
    var classes = (_a = {}, _a[vdl_prefix_1.vdlPrefix('list__option')] = true, _a[vdl_prefix_1.vdlPrefix('list__option--focus')] = focused, _a[vdl_prefix_1.vdlPrefix('list__option--selected')] = selected, _a[vdl_prefix_1.vdlPrefix('list__option--disabled')] = disabled, _a[vdl_prefix_1.vdlPrefix('list__option--readonly')] = readOnly, _a[vdl_prefix_1.vdlPrefix('list__option--empty')] = empty, _a);
    return react_1.default.createElement("li", __assign({}, customProps, {
      role: role,
      tabIndex: !(disabled || readOnly) ? -1 : undefined,
      "aria-selected": !!selected,
      className: classnames_1.classNames(className, classes)
    }), children);
  };
  ListOption.propTypes = {
    dataItem: prop_types_1.default.any,
    focused: prop_types_1.default.bool,
    selected: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    empty: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    children: prop_types_1.default.node,
    role: prop_types_1.default.string
  };
  ListOption.defaultProps = {
    role: 'option'
  };
  return ListOption;
}(react_1.default.PureComponent);
exports.ListOption = ListOption;